import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getCooperationTypeList(params) {
  return request({
    url: URL.mdm.basicData.cooperationTypeList,
    method: 'get',
    params
  })
}

export function saveCooperationType(data) {
  return request({
    url: URL.mdm.basicData.cooperationType,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delCooperationType(data) {
  return request({
    url: URL.mdm.basicData.cooperationType,
    method: 'delete',
    data
  })
}

export function initCooperationType() {
  return request({
    url: URL.mdm.basicData.initCooperationType,
    method: 'post'
  })
}

